import React, { Component } from "react";
import gql from "graphql-tag";
import { Row, Col } from "react-flexbox-grid";
import { Query } from "react-apollo";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Fab from "@material-ui/core/Fab";
import EditIcon from "@material-ui/icons/Edit";
import { Link } from "react-router-dom";
import DeleteIndicatorButton from "./delete-indicator-button";
import { ListLoader } from "../../commons/loaders";

const GET_INDICATORS = gql`
	{
		allIndicators {
			_id
			name
			description
			paletteType
			deleted
		}
	}
`;

const styles = (theme) => ({
	table: {
		minWidth: 700
	},
	fab: {
		margin: theme.spacing.unit
	}
});

function mapPaletteType(type) {
	switch (type) {
		case "DIVERGENT":
			return "Divergente";
		case "SEQUENTIAL":
			return "Secuencial";
		case "INVERTED_SEQUENTIAL":
			return "Secuencial invertido";
		default:
			return type;
	}
}

class IndicatorsTable extends Component {
	render() {
		const { classes } = this.props;
		return (
			<Query query={GET_INDICATORS} fetchPolicy="cache-and-network">
				{({ loading, error, data }) => {
					if (loading) return <ListLoader count={8} />;
					if (error) return `Error! ${error.message}`;

					return (
						<Table
							className={classes.table}
							aria-labelledby="indicators"
							size="small"
						>
							<TableHead>
								<TableRow>
									<TableCell align="left">Nombre Indicador</TableCell>
									<TableCell align="left">Descripción</TableCell>
									<TableCell align="left">Paleta</TableCell>
									<TableCell align="left">Acciones</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{data.allIndicators
									.filter((row) => !row.deleted)
									.map((row) => {
										return (
											<TableRow key={row._id}>
												<TableCell>{row.name}</TableCell>
												<TableCell component="th" scope="row" align="left">
													{row.description}
												</TableCell>
												<TableCell align="left">
													{mapPaletteType(row.paletteType)}
												</TableCell>
												<TableCell align="left">
													<Row>
														<Col>
															<Fab
																size="small"
																aria-label="Edit"
																className={classes.fab}
																component={Link}
																to={`/admin/indicators-details/${row._id}/`}
															>
																<EditIcon />
															</Fab>
														</Col>
														<Col>
															<DeleteIndicatorButton
																row={row}
																query={GET_INDICATORS}
															/>
														</Col>
													</Row>
												</TableCell>
											</TableRow>
										);
									})}
							</TableBody>
						</Table>
					);
				}}
			</Query>
		);
	}
}

export default withStyles(styles)(IndicatorsTable);



// WEBPACK FOOTER //
// ./src/components/admin/indicators/table.js